import React from 'react';
import './App.css';
import { LandingPage } from './dist/LandingPage';

function App(props) {
  const { finalIsDarkMode } = props;

  return (
    <>
      { LandingPage(finalIsDarkMode) }
    </>
  )
}

export default App;
